import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-00 «Вхід». Читается при сборке: тека с этим файлом —
// это и есть регистрация, общих файлов при этом никто не правит.
//
// ⚠ Пунктом меню `S-00` не является и отметкой пресета не выдаётся: вход есть у
// каждого, у кого есть действующая учётная запись (`ENT-26`). Меню собирается
// не из этого реестра, а из того, что отдаёт `/api/auth/me` (`surfaces`), и
// вход сервер в этот перечень не кладёт (`visible_surfaces`).
//
// ⚠ Это **корень навигации** (`G71`): в `S-00` не ведёт ни одна строка системы.
export const meta: SurfaceMeta = {
  code: "S-00",
  // Название — слово словаря по коду (`G117`, таск 74), читается при показе.
  get title_uk() {
    return w("s00_title");
  },
  path: "/s-00",
};
